import {AlarmAck} from "../entities/AlarmAck";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class AlarmAckService extends BaseService<AlarmAck>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, AlarmAck);
    }
    protected getBaseUrl():string{
        return "alarmack";
    }
}
